import { call, takeEvery, all } from 'redux-saga/effects';

import {
  createPublication,
} from 'api/content';
import { CONTENT_ACTION_TYPES } from 'store/actions/content.actions';

function* createPublicationFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { photos, videos, userId, ...rest } = payload;
    rest.user = `/users/${userId}`;
    if (photos) {
      rest.photos = photos.map(({ '@id': linkId }) => linkId);
    }
    if (videos) {
      rest.videos = videos.map(({ '@id': linkId }) => linkId);
    }
    const { data } = yield call(createPublication, rest);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

export default function* () {
  yield all([
    takeEvery(CONTENT_ACTION_TYPES.CREATE_PUBLICATION, createPublicationFlow),
  ]);
}
